import styled from 'styled-components'

export const PillButtonStyled = styled.button<{ selected?: boolean }>`
  background: ${props => props.selected ? '#3D6666' : '#fff'};
  border-radius: 30px;
  color: ${props => props.selected ? '#fff' : '#7B7C82'};
  border: 2px solid ${props => props.selected ? '#CED8D4' : '#CED8D8'};
  padding: 4px 16px;
`